/**
 * @flow
 * @relayHash 2d6a2ce892ce02209e507e2a7a1ec407
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePortfolioAssetInput = {|
  fileName: string,
  description?: ?string,
  stagedPath?: ?string,
  clientMutationId?: ?string,
|};
export type CreatePortfolioAssetMutationVariables = {|
  input: CreatePortfolioAssetInput
|};
export type CreatePortfolioAssetMutationResponse = {|
  +createPortfolioAsset: ?{|
    +newAsset: ?{|
      +id: string
    |}
  |}
|};
export type CreatePortfolioAssetMutation = {|
  variables: CreatePortfolioAssetMutationVariables,
  response: CreatePortfolioAssetMutationResponse,
|};
*/


/*
mutation CreatePortfolioAssetMutation(
  $input: CreatePortfolioAssetInput!
) {
  createPortfolioAsset(input: $input) {
    newAsset {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePortfolioAssetInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createPortfolioAsset",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreatePortfolioAssetPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "newAsset",
        "storageKey": null,
        "args": null,
        "concreteType": "AssetNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreatePortfolioAssetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreatePortfolioAssetMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreatePortfolioAssetMutation",
    "id": null,
    "text": "mutation CreatePortfolioAssetMutation(\n  $input: CreatePortfolioAssetInput!\n) {\n  createPortfolioAsset(input: $input) {\n    newAsset {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8971485976404ac06920ade9f2c48728';
module.exports = node;
